import {
    SALESHEAD_REQUISITION,
   } from "./actionType";
   
   // common success
   export const StoreSalesHeadRequisition = (requsition) => ({
     type: SALESHEAD_REQUISITION,
     payload:requsition,
   });
  